import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { EverythingIncluded } from './components/EverythingIncluded';
import { VisualSection } from './components/VisualSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
const SITE_TITLE = 'Dental Instructor Atlas | 6-in-1 Visual Dentistry Teaching & Clinical Training System';
const SITE_DESCRIPTION = 'The complete 6-in-1 visual dentistry teaching and clinical training system for dental instructors, clinical faculty and dental educators: 6 volumes, 300 visual training pages and 5 bonuses. Instant access.';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
}
export function App({
  showTestimonials = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    document.title = SITE_TITLE;
    try {
      const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
        let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute(attr, key);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      };
      setMeta('name', 'description', SITE_DESCRIPTION);
      setMeta('property', 'og:title', SITE_TITLE);
      setMeta('property', 'og:description', SITE_DESCRIPTION);
      setMeta('property', 'og:type', 'website');
      setMeta('name', 'twitter:card', 'summary_large_image');
      setMeta('name', 'theme-color', '#0F4C5C');
    } catch (error) {
      console.warn('Meta tags update failed:', error);
    }
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-slate-700 antialiased" data-id="element-0" data-mp="1r5ahppgnq59i">
      <main data-id="element-1" data-mp="1w3vj3s7nauzj">
        <Hero data-id="element-2" data-mp="1w2aq470zbk3s" />
        {showTestimonials && <TestimonialsStrip data-id="element-3" data-mp="1w19f22jyqxm2" />}
        <ProductGallery data-id="element-4" data-mp="1i3ukykirm1nr" />
        <PainPoints data-id="element-5" data-mp="1i4ch7h5fgfvo" />
        <SolutionReveal data-id="element-6" data-mp="1i31ab8goqs0c" />
        <VisualSection data-id="element-7" data-mp="1i5nldi2sbpnb" />
        <VolumesSection data-id="element-8" data-mp="1m4wcsgacrbfp" />
        <BonusSection data-id="element-9" data-mp="1m44rbyagyu35" />
        <PricingSection data-id="element-10" data-mp="1m3l7ud567xn0" />
        <ClosingArgument data-id="element-11" data-mp="1m70qfpy1zot6" />
        <Guarantee data-id="element-12" data-mp="6nw7m4gk0tgq" />
        <FAQ data-id="element-13" data-mp="6ncm6drp3mxy" />
        <FinalCTA data-id="element-14" data-mp="6muiiw2pe6g0" />
        <EverythingIncluded data-id="element-15" data-mp="6qie00rpl2xd" />
      </main>
      <Footer data-id="element-16" data-mp="aqisflet5e4f" />
      <noscript data-id="element-17" data-mp="ar29kzwmvyhe">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-18" data-mp="arkf6n56rp1z" />
      </noscript>
    </div>;
}